"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VelvetTokenManager = void 0;
var tslib_1 = require("tslib");
var constants_1 = require("../../../../constants/constants");
var sdk_1 = require("../../../../sdk/sdk");
var utils_1 = require("../../../../utils/utils");
var networkServiceDefault_1 = require("../../../network/networkServiceDefault");
var RefreshTokenError = /** @class */ (function (_super) {
    tslib_1.__extends(RefreshTokenError, _super);
    function RefreshTokenError() {
        var _this = _super.call(this) || this;
        Object.setPrototypeOf(_this, RefreshTokenError.prototype);
        return _this;
    }
    return RefreshTokenError;
}(Error));
/**
 * Implementation of the TokenProvider interface for Velvet authentication.
 * @class
 * @implements {TokenProvider}
 */
var VelvetTokenManager = /** @class */ (function () {
    function VelvetTokenManager(networkService) {
        if (networkService === void 0) { networkService = new networkServiceDefault_1.NetworkServiceDefault(); }
        this.networkService = networkService;
    }
    VelvetTokenManager.prototype.getTokens = function () {
        try {
            var authTokens = (0, utils_1.getLocalStorageItemByKey)(constants_1.userTokensLS);
            return authTokens !== null && authTokens !== void 0 ? authTokens : null;
        }
        catch (error) {
            console.log('Error getting user tokens:', error);
            return null;
        }
    };
    VelvetTokenManager.prototype.saveTokens = function (userTokens) {
        (0, utils_1.saveObjectToLocalStorage)(constants_1.userTokensLS, userTokens);
    };
    VelvetTokenManager.prototype.removeTokens = function () {
        (0, utils_1.removeItemFromLocalStorage)(constants_1.userTokensLS);
    };
    VelvetTokenManager.prototype.refreshTokens = function () {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var userTokens, isAccessTokenValid, isRefreshTokenValid, config, baseUrl, tokenRefreshPath, url, requestable, response, newUserTokens, error_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        userTokens = this.getTokens();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        if (!userTokens) return [3 /*break*/, 3];
                        isAccessTokenValid = (0, utils_1.isTokenValid)(userTokens.accessToken);
                        isRefreshTokenValid = (0, utils_1.isTokenValid)(userTokens.accessRefreshToken);
                        // Check if the access token is valid, then return it
                        if (isAccessTokenValid) {
                            return [2 /*return*/, userTokens];
                        }
                        // Check if the refresh token is invalid, then logout the user
                        if (!isRefreshTokenValid) {
                            window.postMessage({ type: constants_1.Notification.LOGOUT_USER });
                            return [2 /*return*/, null];
                        }
                        config = sdk_1.VelvetSDK.Configuration.configuration;
                        baseUrl = config === null || config === void 0 ? void 0 : config.apiEndpointBaseUrl;
                        tokenRefreshPath = (_a = config === null || config === void 0 ? void 0 : config.apiEndpoints) === null || _a === void 0 ? void 0 : _a.tokenRefresh;
                        url = tokenRefreshPath.replace(constants_1.CMS.BASE_URL, baseUrl);
                        if (!baseUrl || !tokenRefreshPath) {
                            throw new Error('Missing required SDK configuration');
                        }
                        requestable = {
                            url: url,
                            method: constants_1.HTTP_METHOD.POST,
                            body: { refreshToken: userTokens.accessRefreshToken },
                        };
                        return [4 /*yield*/, this.networkService.fetch(requestable)];
                    case 2:
                        response = _b.sent();
                        newUserTokens = {
                            accessToken: response.token,
                            accessRefreshToken: response.refreshToken,
                        };
                        this.saveTokens(newUserTokens);
                        return [2 /*return*/, newUserTokens];
                    case 3: return [2 /*return*/, null];
                    case 4:
                        error_1 = _b.sent();
                        console.log('Error getting user tokens', error_1);
                        throw new RefreshTokenError();
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return VelvetTokenManager;
}());
exports.VelvetTokenManager = VelvetTokenManager;
